/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../global-graphql-types'

import { DocumentNode } from 'graphql'
import * as Apollo from '@apollo/client'
import * as ApolloReactHooks from 'utils/extendApolloHooks'
const defaultOptions = {} as const
export type CustomerEmailCodeSignupVariables = Types.Exact<{
  emailToken: Types.Scalars['String']
  firstName: Types.Scalars['String']
  lastName: Types.Scalars['String']
  phone: Types.Scalars['String']
  subscribeToLotId: Types.InputMaybe<Types.Scalars['Int']>
}>

export type CustomerEmailCodeSignup = {
  __typename: 'Root'
  customerEmailCodeSignup: {
    __typename: 'CustomerEmailCodeSignupPayload'
    redirectTo: string | null
    customer: {
      __typename: 'Customer'
      id: number
      authenticationToken: string
      email: string
      completeProfile: boolean
      anonymous: boolean
      phone: any | null
      firstName: string | null
      lastName: string | null
    } | null
    errors: Array<{
      __typename: 'UserError'
      fullMessage: string | null
      key: string | null
      message: string | null
    }> | null
  } | null
}

export const CustomerEmailCodeSignupDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'CustomerEmailCodeSignup' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'emailToken' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'firstName' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'lastName' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'phone' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'subscribeToLotId' }
          },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'customerEmailCodeSignup' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'emailToken' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'emailToken' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'firstName' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'firstName' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'lastName' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'lastName' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'phone' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'phone' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'subscribeToLotId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'subscribeToLotId' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'customer' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'authenticationToken' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'email' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'completeProfile' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'anonymous' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'phone' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'firstName' }
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'lastName' }
                      }
                    ]
                  }
                },
                { kind: 'Field', name: { kind: 'Name', value: 'redirectTo' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'errors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fullMessage' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode
export type CustomerEmailCodeSignupMutationFn = Apollo.MutationFunction<
  CustomerEmailCodeSignup,
  CustomerEmailCodeSignupVariables
>

/**
 * __useCustomerEmailCodeSignup__
 *
 * To run a mutation, you first call `useCustomerEmailCodeSignup` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCustomerEmailCodeSignup` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [customerEmailCodeSignup, { data, loading, error }] = useCustomerEmailCodeSignup({
 *   variables: {
 *      emailToken: // value for 'emailToken'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      phone: // value for 'phone'
 *      subscribeToLotId: // value for 'subscribeToLotId'
 *   },
 * });
 */
export function useCustomerEmailCodeSignup(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    CustomerEmailCodeSignup,
    CustomerEmailCodeSignupVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    CustomerEmailCodeSignup,
    CustomerEmailCodeSignupVariables
  >(CustomerEmailCodeSignupDocument, options)
}
export type CustomerEmailCodeSignupHookResult = ReturnType<
  typeof useCustomerEmailCodeSignup
>
export type CustomerEmailCodeSignupMutationResult =
  Apollo.MutationResult<CustomerEmailCodeSignup>
export type CustomerEmailCodeSignupMutationOptions = Apollo.BaseMutationOptions<
  CustomerEmailCodeSignup,
  CustomerEmailCodeSignupVariables
>
